import React from "react";
import { motion } from "framer-motion";

export default function StatsCard({ title, value, subtitle, icon: Icon, color = "green", trend, trendValue }) {
  const colorClasses = {
    green: "bg-gradient-to-br from-[#2D6A4F] to-[#1B4332]",
    gold: "bg-gradient-to-br from-[#D4A373] to-[#BC8A5F]",
    red: "bg-gradient-to-br from-red-500 to-red-600",
    blue: "bg-gradient-to-br from-blue-500 to-blue-600",
    stone: "bg-gradient-to-br from-stone-600 to-stone-700"
  };

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      className={`${colorClasses[color]} rounded-2xl p-6 text-white shadow-lg relative overflow-hidden`}
    >
      <div className="absolute top-0 right-0 w-32 h-32 bg-white/5 rounded-full -translate-y-16 translate-x-16" />
      <div className="absolute bottom-0 left-0 w-24 h-24 bg-white/5 rounded-full translate-y-12 -translate-x-12" />
      
      <div className="relative">
        <div className="flex items-start justify-between mb-4">
          <div className="p-3 bg-white/20 rounded-xl">
            <Icon className="w-6 h-6" />
          </div>
          {trend && (
            <span className={`text-sm font-medium px-2 py-1 rounded-full ${
              trend === 'up' ? 'bg-green-400/30 text-green-100' : 'bg-red-400/30 text-red-100'
            }`}>
              {trend === 'up' ? '↑' : '↓'} {trendValue}
            </span>
          )}
        </div>
        
        <p className="text-white/70 text-sm font-medium mb-1">{title}</p>
        <p className="text-3xl font-bold mb-1">{value}</p>
        {subtitle && <p className="text-white/60 text-sm">{subtitle}</p>}
      </div>
    </motion.div>
  );
}